﻿{
  "favoriteBoardmakerSoftware": "Favoritsoftware fra Boardmaker",
  "planDetailsStartTrial": "Start din gratis prøveperiode i dag, og få adgang i 30 dage!",
  "community": {
    "summary": "Benyt dig af brugsklart tilgængeligt undervisningsmateriale, der deles af forældre, undervisere og pædagoger som dig! Spar tid, når du søger efter og filtrerer aktiviteter og skabeloner. Føj dem derefter til din konto, og du er klar til at redigere og bruge dem med din favoritsoftware fra Boardmaker. Der findes 60.000 GRATIS aktiviteter til udskrivning og interaktive aktiviteter, og der er mere end 500.000 medlemmer, så hvad venter du på?",
    "topReasons": {
      "header": "Vigtigste grunde til at tilmelde dig myBoardmaker Community",
      "points": [
        "Del dine egne fantastiske aktiviteter",
        "Find, hvad du behøver, med stærke søgefunktioner",
        "Find professionelle aktiviteter oprettet af Boardmakers undervisningsteam",
        "Søg efter aktiviteter tilpasset Common Core-standarder",
        "Meld dig ind i grupper, der passer til dine interesser"
      ]
    },
    "summaryEnd": "Del, og udforsk interaktive materialer og materialer til udskrivning, der indeholder adfærdsstøtter, fremmer elevers selvstændighed og udvikler færdigheder. Alt sammen GRATIS.",
    "features": [
      {
        "featureTitle": "Find",
        "featureDescription": "Find tilpassede læseplaner, visuelle tidsplaner, kommunikationstavler, aktiviteter tilpasset undervisningsstandarder og andre støtter, der er udviklet og bruges af forældre, pædagoger og undervisere."
      },
      {
        "featureTitle": "Del",
        "featureDescription": "Overfør dine egne aktiviteter, deltag i drøftelser, opret offentlige og private grupper til deling og meget mere."
      },
      {
        "featureTitle": "Brug",
        "featureDescription": "Gem dine aktiviteter online, og få adgang til dem fra en vilkårlig computer."
      },
      {
        "featureTitle": "Forbind",
        "featureDescription": "Forbind med andre, som underviser i samme emne eller på samme klassetrin, udveksl idéer med forældre med samme udfordringer som dig, og del dine egne løsninger."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senere"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senere"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senere"]
      ],
      "browser": [
        ["Chrome", "v49.0", "aktuel"],
        ["Firefox", "v38.0", "aktuel"],
        ["Safari", "v11.0", "aktuel"],
        ["Edge", "v83.0.478.45", "aktuel"],
        ["Internet Explorer", "v10.0", "v11.0 eller senere"]
      ]
    }
  },
  "personal": {
    "summary": "Brug Boardmaker derhjemme. Et abonnement på myBoardmaker Personlig giver dig mulighed for at spille en aktiv rolle i dit barns succes ved at skabe sammenhæng mellem hjem, skole og behandling og derved mulighed for at udvide læring ud over skoledagen og skoleåret. Netværk med andre forældre i Boardmaker Community, del dit eget arbejde, og få idéer til meget mere.",
    "topReasons": {
      "header": "Vigtigste grunde til at tilmelde dig myBoardmaker Personal",
      "points": [
        "Få engagerende og interaktive aktiviteter på en vilkårlig computer eller iPad",
        "Print aktiviteter efter behov",
        "Spil som forælder en aktiv rolle i dit barns læring derhjemme",
        "Tag sjove og engagerende materialer med dig på farten, og opret eller redigér aktiviteter på en vilkårlig computer"
      ]
    },
    "summaryEnd": "Start din gratis prøveperiode i dag, og få fuld adgang i 30 dage!",
    "features": [
      {
        "featureTitle": "Opret og redigér",
        "featureDescription": "Opret og redigér symboltilpassede aktiviteter, såsom visuelle tidsplaner til planlægning af din dag, individualiserede bøger og undervisningsmaterialer samt adfærdsstøtter! Vælg fra et bibliotek med over 80.000 symboler. Der tilføjes nye symboler hver anden uge, og mulighederne er uanede. Har du brug for mere? Brug vores søgemulighed til at finde mediafiler til dit projekt på internettet."
      },
      {
        "featureTitle": "Print og afspil",
        "featureDescription": "Print dine egne aktiviteter eller dem, du finder på Boardmaker Community, direkte fra din webbrowser, og brug dem sammen med dit barn. Vil du gerne styrke engagementet? Prøv vores interaktive skabeloner og aktiviteter. Børn og forældre kan nemt afspille aktiviteter via den gratis app Student Center på deres tablet eller kommunikationsenhed."
      },
      {
        "featureTitle": "Undervis og udvid",
        "featureDescription": "Kickstart dit barns sprog- samt læse- og skrivefærdigheder med vores tre brugervenlige læseplansprogrammer. Start med Core First Learning – Et værktøj der hjælper dit barn med at lære meningen, brugen og placeringen af hyppigt anvendte kerneord. Ideelt til personer, der bruger kernebaserede assisterende kommunikationssystemer, eller til personer, der er ved at lære at læse! Brug de nye færdigheder sammen med litteratur på klasseniveau ved at indgå i dialog med Book Bridge, og begynd derefter at opbygge kendskab til verden via udforskning af historie, geografi, liv og kultur sammen med Expedition Education."
      },
      {
        "featureTitle": "Find og del",
        "featureDescription": "Hvorfor genopfinde hjulet? Vælg mellem mere end 60.000 GRATIS brugsklare aktiviteter til udskrivning og interaktive aktiviteter og 1.100 kategoriopdelte offentlige grupper i Boardmaker Community – det største delefællesskab af sin art i verden. Du kan også overføre dine egne aktiviteter til din konto med myBoardmaker Community og dele dem med forældre, pædagoger eller din elevs supportteam."
      },
      {
        "featureTitle": "Overvåg og registrér",
        "featureDescription": "Overvåg og registrér dit barns fremskridt med arbejdet med aktiviteter for at sikre succes og hjælpe dig med at finde den mest effektive metode."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senere"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senere"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senere"]
      ],
      "browser": [
        ["Chrome", "v49.0", "aktuel"],
        ["Firefox", "v38.0", "aktuel"],
        ["Safari", "v11.0", "aktuel"],
        ["Edge", "v83.0.478.45", "aktuel"],
        ["Internet Explorer", "v10.0", "v11.0 eller senere"]
      ]
    }
  },
  "professional": {
    "summary": "Boardmaker Online Professional er det mest komplette system til undervisere inden for specialundervisning, talepædagoger, ergoterapeuter, adfærdsterapeuter osv., hvor de kan finde, oprette, organisere og bruge tilpassede visuelle støtter, aktiviteter til symbolbaseret kommunikation og behandling, der dækker behovet hos eleverne i dit klasseværelse eller på dit sagsområde.",
    "topReasons": {
      "header": "Vigtigste grunde til at tilmelde dig myBoardmaker Professional",
      "points": [
        "Administrér, og tildel elevaktiviteter overalt på en vilkårlig computer",
        "Brug det store bibliotek med eksempelaktiviteter, der er tilpasset standarderne, eller opret dit eget",
        "Eleverne kan få adgang til undervisningsaktiviteter fra en vilkårlig computer eller iPad i skolen eller derhjemme",
        "Indsaml data, og registrér elevernes fremskridt i forhold til IEP elevmålene og standarder for undervisning",
        "Indbyggede værktøjer hjælper dig med at samarbejde og dele med andre teammedlemmer"
      ]
    },
    "summaryEnd": "Start din gratis prøveperiode i dag, og få fuld adgang i 30 dage!",
    "features": [
      {
        "featureTitle": "Opret og redigér",
        "featureDescription": "Opret og redigér symboltilpassede aktiviteter, såsom visuelle tidsplaner til planlægning af din dag, individualiserede bøger og undervisningsmaterialer samt adfærdsstøtter! Vælg fra et bibliotek med over 80.000 symboler. Der tilføjes nye symboler hver anden uge, og mulighederne er uanede. Har du brug for mere? Brug vores søgemulighed til at finde mediafiler til dit projekt på internettet."
      },
      {
        "featureTitle": "Print og afspil",
        "featureDescription": "Print dine egne aktiviteter eller dem, du finder på Boardmaker Community, direkte fra din webbrowser, og brug dem sammen med dit barn. Vil du gerne styrke engagementet? Prøv vores interaktive skabeloner og aktiviteter. Børn og forældre kan nemt afspille aktiviteter via den gratis app Student Center på deres tablet eller kommunikationsenhed."
      },
      {
        "featureTitle": "Undervis og udvid",
        "featureDescription": "Hjælp din elev med det næste trin på elevens undervisningsrejse med adgang til tre effektive læseplansprogrammer, der er tilpasset standarderne. Boardmaker Instructional Solutions, der er en del af abonnementet til myBoardmaker, har over 140 trinvise lektionsplaner, mere end 1.500 forskellige aktiviteter tilpasset standarderne, over 300 udskriftklare bøger, værktøjer til klasseadministration, quizzer, spil, opskrifter, håndværk og meget mere!"
      },
      {
        "featureTitle": "Find og del",
        "featureDescription": "Hvorfor genopfinde hjulet? Vælg mellem mere end 60.000 GRATIS brugsklare aktiviteter til udskrivning og interaktive aktiviteter og 1.100 kategoriopdelte offentlige grupper i Boardmaker Community – det største delefællesskab af sin art i verden. Du kan også overføre dine egne aktiviteter til din konto med myBoardmaker Community og dele dem med forældre, pædagoger eller din elevs supportteam."
      },
      {
        "featureTitle": "Overvåg og registrér",
        "featureDescription": "Overvåg og registrér dit barns fremskridt med arbejdet med aktiviteter for at sikre succes og hjælpe dig med at finde den mest effektive metode."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senere"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senere"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senere"]
      ],
      "browser": [
        ["Chrome", "v49.0", "aktuel"],
        ["Firefox", "v38.0", "aktuel"],
        ["Safari", "v11.0", "aktuel"],
        ["Edge", "v83.0.478.45", "aktuel"],
        ["Internet Explorer", "v10.0", "v11.0 eller senere"]
      ]
    }
  },
  "organization": {
    "summary": "Boardmaker Online Organization understøtter dit tværfaglige team med tilpassede aktiviteter, adfærdsstøtter og måling af fremskridt i forhold til opnåelse af standarder og mål. \n\nBoardmaker Online, der er cloudbaseret, skaber grundlag for sammenhæng og samarbejde på tværs af hele organisationen og giver medarbejderne mulighed for at arbejde overalt. De får også adgang til et bibliotek med mere end 60.000 brugsklare aktiviteter, tre fulde læseplansprogrammer og over 80.000 PCS-symboler til at kickstarte deres lektionsplanlægning. Dine medarbejdere kan nu hurtigt udlevere udskrifter af aktiviteter og interaktive aktiviteter til eleverne eller klienterne, der bruger Boardmaker Student Center, og udvide læring og behandling blot ved et tryk på en knap!\n\nFølg brug af medarbejdere, og styrk effektiviteten i hele organisationen ved at administrere konti og data centralt samt med avancerede delings- og samarbejdsværktøjer.",
    "topReasons": {
      "header": "Vigtigste grunde til at tilmelde dig myBoardmaker Organisation",
      "points": [
        "Et cloudbaseret system giver sammenhæng og samarbejde i hele organisationen og medarbejderne mulighed for at arbejde overalt",
        "Et omfattende bibliotek med eksempelaktiviteter, der allerede er tilpasset de amerikanske College and Career Readiness Standards og dit lands specifikke standarder",
        "Eleverne kan få adgang til undervisningsaktiviteter overalt fra en vilkårlig computer",
        "Aktiviteter kan knyttes til IEP elevmål for at vise elevresultater",
        "Øjeblikkelig adgang til data om elevresultater og brug af medarbejdere via et og samme system"
      ]
    },
    "summaryEnd": "",
    "features": [
      {
        "featureTitle": "Opret og redigér",
        "featureDescription": "Opret og redigér symboltilpassede aktiviteter, såsom visuelle tidsplaner til planlægning af din dag, individualiserede bøger og undervisningsmaterialer samt adfærdsstøtter! Vælg fra et bibliotek med over 80.000 symboler. Der tilføjes nye symboler hver anden uge, og mulighederne er uanede. Har du brug for mere? Brug vores søgemulighed til at finde mediafiler til dit projekt på internettet."
      },
      {
        "featureTitle": "Print og afspil",
        "featureDescription": "Print dine egne aktiviteter eller dem, du finder på Boardmaker Community, direkte fra deres webbrowser. Vil du gerne styrke engagementet? Tilskynd dit team til at bruge vores interaktive skabeloner og aktiviteter. Eleverne kan nemt afspille aktiviteter med den gratis app Student Center med fuld adgang uden internetforbindelse."
      },
      {
        "featureTitle": "Undervis og udvid",
        "featureDescription": "Giv dine medarbejdere adgang til tre effektive læseplansprogrammer, der er tilpasset standarderne. Alle er inkluderet i abonnementet til myBoardmaker Organization. Boardmaker Instructional Solutions har over 140 trinvise lektionsplaner, over 1.500 forskellige aktiviteter tilpasset til standarderne, over 300 udskriftsklare bøger, værktøjer til klasseadministration, quizzer, spil, opskrifter, kunsthåndværk og meget mere!"
      },
      {
        "featureTitle": "Tildel og registrér",
        "featureDescription": "Medarbejderne kan med en konto til myBoardmaker Organization tildele brugerdefinerede og niveauinddelte aktiviteter til et ubegrænset antal elever og registrere den enkelte elevs fremskridt i forhold til IEP elevmålene samt nationale og lokale standarder. De kan derefter ved hjælp af værktøjet til måling af fremskridt hurtigt henvise til elevernes resultater og rapportere herom på en nem måde. Det er også muligt at registrere aktiviteter tildelt som hjemmearbejde, så hjemmearbejdet kan administreres effektivt, og medarbejderne kan samarbejde med barnets familie om at udvide læringen ud over klasseværelset."
      },
      {
        "featureTitle": "Find og del",
        "featureDescription": "Hvorfor genopfinde hjulet? Vælg mellem mere end 60.000 GRATIS brugsklare aktiviteter til udskrivning og interaktive aktiviteter og 1.100 kategoriopdelte offentlige grupper i Boardmaker Community – det største delefællesskab af sin art i verden. Du kan også overføre dine egne aktiviteter til din konto med myBoardmaker Community og dele dem med forældre, pædagoger eller din elevs supportteam."
      }
    ],
    "advantages": [
      {
        "advantageTitle": "Lavere udgifter",
        "advantagePoints": [
          "Specielle, tilpassede organisationspakker til mere end 5 konti",
          "Cloudbaserede tjenester giver mulighed for nem tildeling af licenser i tilfælde af udskiftning af medarbejdere",
          "Mængderabat",
          "Pakker med flere produkter",
          "Besparelser over flere år"
        ]
      },
      {
        "advantageTitle": "Alle vinder",
        "advantagePoints": [
          "Forskningsbaserede og brugsklare aktiviteter giver positive, målelige resultater",
          "Vores tilpassede undervisningsmateriale og aktiviteter, der følger principperne for Universaldesign for Læring, gør målene for læring opnåelige for personer med forskellige evner",
          "Tilpassede læseplaner giver lige adgang for alle",
          "Tilgængelige ressourcer, der inddrager best practices fra eksterne eksperter og sikrer, at du får mest muligt ud af dine løsninger"
        ]
      },
      {
        "advantageTitle": "Understøtter standarder og krav",
        "advantagePoints": [
          "Løsninger designet specifikt til at undervise og måle fremskridt i forhold til standarder for egnethed til videreuddannelse og job",
          "Bred vifte af løsninger, der understøtter kravene i Universaldesign for Læring, Every Child Succeeds og den amerikanske lovgivning om undervisning af personer med handicap",
          "Registrér, og rapportér automatisk om fremskridt i forhold til målene i individuelle undervisningsplaner via dashboards til data"
        ]
      },
      {
        "advantageTitle": "Nem udrulning i organisationen",
        "advantagePoints": [
          "Sætter administratorer i stand til at levere og udrulle konti via fjernadministration på bare få sekunder",
          "Fleksible og skalérbare muligheder for udrulning i organisationer",
          "Alle cloudbaserede løsninger opbevares i et Tier-1 datacenter med høj sikkerhed",
          "Gratis automatiske cloudbaserede opdateringer med nye spændende funktioner og ressourcer"
        ]
      }
    ],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "Windows 10", "Windows 10 eller senere"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senere"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 or later"]
      ],
      "browser": [
        ["Chrome", "v49.0", "aktuel"],
        ["Firefox", "v38.0", "aktuel"],
        ["Safari", "v11.0", "aktuel"],
        ["Edge", "v83.0.478.45", "aktuel"],
        ["Internet Explorer", "v10.0", "v11.0 eller senere"]
      ]
    }
  },
  "boardmakerLicense": {
    "summary": "Den næste generation af Boardmaker-software er her!  Boardmaker 7 tager de bedste funktioner fra alle tidligere versioner af Boardmaker og kombinerer dem i en app til flere platforme og på flere sprog.  Boardmaker 7 har en enkel brugergrænseflade, der placerer værktøjerne lige ved fingerspidserne.  De seneste PCS-symboler følger med. Programmet er bagudkompatibelt med alle dine gamle tavler og aktiviteter. Den nye software giver dig mulighed for at oprette og udlevere tilpassede læseplans- og kommunikationsstøtter hurtigere end nogensinde før.",
    "topReasons": {
      "header": "Vigtigste grunde til at købe Boardmaker 7-software",
      "points": [
        "Redigér, print og afspil alle dine gamle Boardmaker-filer",
        "Intuitiv, moderne brugergrænseflade med indbyggede tip og undervisningsmaterialer",
        "Flotte skabeloner, der hurtigt og nemt kan tilpasses",
        "Find hurtigt de symboler og billeder, du skal bruge"
      ]
    },
    "summaryEnd": "Download din 30 dages gratis prøveperiode i dag!",
    "features": [
      {
        "featureTitle": "Åbner alt, du har oprettet",
        "featureDescription": "Lad ikke alt det hårde arbejde gå tabt ... Med Boardmaker 7-softwaren kan du åbne alle filer, der er oprettet med Boardmaker v5, Boardmaker v6 og Boardmaker Studio.  Konvertering er hurtig og præcis. Selv komplekse interaktive aktiviteter fungerer og ligner originalen på en prik."
      },
      {
        "featureTitle": "Det er nemt, nemt, nemt",
        "featureDescription": "Brugerne har talt!  Brugergrænsefladen til Boardmaker 7-softwaren er moderne, indbydende og intuitiv og er designet på grundlag af omfattende test af brugere som dig selv.  De indbyggede tip og undervisningsmaterialer giver dig tillid til at udforske, udvide dine færdigheder og, mest vigtigt, støtte dine elever."
      },
      {
        "featureTitle": "Hurtig og tidsbesparende",
        "featureDescription": "Du bliver forbløffet over bredden og dybden af, hvad du kan opnå på bare et par minutter med de nydesignede skabeloner til både aktiviteter til udskrivning og interaktive aktiviteter.  Du kan færdiggøre den tidsplan eller sociale fortælling på ingen tid og i stedet koncentrere dig om dine elever.  Boardmaker gør det også nemt at tilpasse dine egne ting, så du får en ideel kombination af hurtighed og fleksibilitet."
      },
      {
        "featureTitle": "Uovertruffen symbolsøgning",
        "featureDescription": "Symboler er, hvem vi er. Boardmaker 7 har en forbedret søgefunktion til symboler og en intuitiv måde til at gennemse symboler efter kategori ... Og det er bare begyndelsen.  Du kan søge efter dele af ord, ord der rimer, individuelle fonemer og konsonant-/vokalmønstre. Der findes intet kraftigere søgeværktøj i dag!  Og skulle du ikke finde det der helt specielle symbol, kan du tilføje billeder hurtigt og nemt med de indbyggede værktøjer til søgning på internettet og til kamera."
      }
    ],
    "advantages": [],
    "requirements": {
      "operatingSystem": [
        ["Windows OS", "10", "Windows 10 eller senere"],
        ["Mac OS", " Mac OSX 10.13", " Mac OSX 10.13 eller senere"],
        ["Chromebook", "Chrome OS 69", "Chrome OS 69 eller senere"]
      ]
    }
  },
  "studio": {
    "requirements": {
      "operatingSystem": [["Windows OS", "7", "Windows 10"]]
    }
  },
  "scmp": {
    "requirements": {
      "operatingSystem": [
        ["Windows ", "7", "Windows 10"],
        ["iOS", "6.0", "IOS 6.0 eller senere"],
        ["Android", "Tobii Dynavox T-Series-enheder", ""]
      ],
      "eyeTracker": [
        ["PCEye Mini", "PCEye Explore", "PCEye Go", "EyeMobile", "I-12", "I-15"]
      ]
    }
  }
}
